import { createContext } from "react";

export const QueryViewerContext = createContext("anonymous");
export const QueryRequestContext = createContext<{
  readonly elevatedPrivileges: boolean;
  readonly reportAuthorizationError: (error: Error) => void;
}>({ elevatedPrivileges: false, reportAuthorizationError: () => {} });
